'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce, isEqual } from 'underscore';
import { NavMarker } from 'react-rhumb';
import Annotation from 'react-codemirror/model/Annotation';
import AnnotationType from 'react-codemirror/enum/AnnotationType';
import { DEFAULT_CONFIG } from 'DesignData/constants/settings/ESLint';
import { INPUT_DEBOUNCE_DELAY } from 'DesignData/constants/FormsAndInput';
import CodeEditorError from 'DesignData/models/validation/CodeEditorError';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
import { toggleJsLint, updateESLintConfig, setESLintDemoErrors } from 'DesignData/actions/settings/user/JavaScriptLinter';
import { getIsEnabled, getEslintConfig, getEslintConfigError } from 'DesignData/selectors/javaScriptLinter';
import JavaScriptLinterComponent from 'DesignManagerIde/components/settings/JavaScriptLinter';
const eslintConfigAnnotationsCache = {
  error: null,
  annotations: EMPTY_ARRAY
};

function makeMapStateToProps() {
  return function mapStateToProps(state) {
    const eslintConfig = getEslintConfig(state);
    return {
      eslintConfig,
      isEnabled: getIsEnabled(state),
      eslintConfigError: getEslintConfigError(state),
      isDefaultEslintConfig: eslintConfig === DEFAULT_CONFIG
    };
  };
}

const mapDispatchToProps = {
  toggleJsLint,
  updateESLintConfig,
  setESLintDemoErrors
};
/**
 * @class Container for JavaScriptLinter settings forms.
 */

class JavaScriptLinter extends Component {
  constructor(...args) {
    super(...args);
    this.onConfigChange = debounce(({
      value
    }) => {
      this.props.updateESLintConfig(value);
    }, INPUT_DEBOUNCE_DELAY);

    this.reset = () => {
      if (this.props.isDefaultEslintConfig) return;
      this.props.updateESLintConfig(DEFAULT_CONFIG);
    };
  }

  get eslintConfigAnnotations() {
    const {
      eslintConfigError
    } = this.props;
    if (!eslintConfigError) return EMPTY_ARRAY;

    if (isEqual(eslintConfigAnnotationsCache.error, eslintConfigError)) {
      return eslintConfigAnnotationsCache.annotations;
    }

    const anno = Object.freeze([new Annotation({
      lineNumber: eslintConfigError.lineNumber,
      column: eslintConfigError.column,
      message: eslintConfigError.message,
      evidence: eslintConfigError.evidence,
      type: AnnotationType.ERROR
    })]);
    eslintConfigAnnotationsCache.error = eslintConfigError;
    eslintConfigAnnotationsCache.annotations = anno;
    return anno;
  }

  /*
   * Render
   */
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "JAVASCRIPT_LINTER_SETTINGS",
      children: /*#__PURE__*/_jsx(JavaScriptLinterComponent, {
        isEnabled: this.props.isEnabled,
        eslintConfig: this.props.eslintConfig,
        eslintConfigAnnotations: this.eslintConfigAnnotations,
        isDefaultEslintConfig: this.props.isDefaultEslintConfig,
        toggleJsLint: this.props.toggleJsLint,
        setESLintDemoErrors: this.props.setESLintDemoErrors,
        onConfigChange: this.onConfigChange,
        reset: this.reset,
        registerToolbarContent: this.props.registerToolbarContent
      })
    });
  }

}

JavaScriptLinter.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  eslintConfig: PropTypes.string.isRequired,
  eslintConfigError: PropTypes.instanceOf(CodeEditorError),
  isDefaultEslintConfig: PropTypes.bool.isRequired,
  toggleJsLint: PropTypes.func.isRequired,
  updateESLintConfig: PropTypes.func.isRequired,
  setESLintDemoErrors: PropTypes.func.isRequired,
  registerToolbarContent: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(JavaScriptLinter);